import gql from 'graphql-tag';

export const GET_ORGANIZATION_BY_ID = gql`
  query($orgId: Int!) {
    organizationDetails(
      userType: PATIENT,
      orgId: $orgId
    ) {
        orgId
        link
      }
  }
`;

export const GET_LOGIN_ORGANIZATION_DETAILS = gql`
  query($orgId: Int!, $locale: String!) {
    organizationDetails(
      userType: PATIENT,
      orgId: $orgId,
      locale: $locale
    ) {
      link
      config {
        patientLoginMethod
        hasTermsAndConditions
        reCaptchaSiteKey
      }
      loginConfig {
        loginText
        externalIdRegexp
        externalIdName
        externalIdNamePlaceholder
        secondaryLoginFields
        secondaryLoginText
        birthDateFormat
        loginErrorText
      }
    }
  }
`;

export const FETCH_ORGANIZATION_LOGO = gql`
  query($orgId: Int!) {
    organizationDetails(
      userType: PATIENT,
      orgId: $orgId
    ) {
        logo
        logoLabels {
          locale
          value
        }
      }
  }
`;

export const FETCH_TERMS_AND_CONDITIONS = gql`
  query($orgId: Int!, $locale: String) {
    organizationDetails(
      userType: PATIENT,
      orgId: $orgId,
      locale: $locale
    ) {
        config {
          termsAndConditions
        }
      }
  }
`;

export const FETCH_ORGANIZATION_ACCESSIBILITY_STATEMENT = gql`
  query($orgId: Int!, $locale: String) {
    organizationDetails(
      userType: PATIENT,
      orgId: $orgId,
      locale: $locale
    ) {
        config {
          accessibilityStatement {
            locale
            value
          }
        }
      }
  }
`;

export const FETCH_SITE_ACCESSIBILITY_STATEMENT = gql`
  query {
    organizationsDetails(
      levelCodes: ["SYSTEM"],
      userType: PATIENT,
    ) {
        config {
          accessibilityStatement {
            locale
            value
          }
        }
      }
  }
`;
